import { Injectable } from "@angular/core";
import { lastValueFrom } from "rxjs";
import { BaseListService } from "../../@core/services/base-list.service";
import { SystemService } from "../../@core/services/system.service";
import { DELETE_PRODUCT_UNIT_CONVERSION_LINK, GET_PRODUCT_UNIT_CONVERSION_LINK, GET_PRODUCT_UNIT_CONVERSION_LINKS, SAVE_PRODUCT_UNIT_CONVERSION_LINK } from "../../data/definitions/unit-conversion.definition";
import { BaseDataService } from "../../data/services/base-data.service";
import { DataService } from "../../data/services/data.service";
import { DeleteProductUnitConversionLinkMutation, DeleteProductUnitConversionLinkMutationVariables, DeletionResponse, GetProductUnitConversionLinkQuery, GetProductUnitConversionLinkQueryVariables, GetProductUnitConversionLinksQuery, GetProductUnitConversionLinksQueryVariables, ProductUnitConversionLink, ProductUnitConversionLinkInput, ProductUnitConversionLinkSearchInput, SaveProductUnitConversionLinkMutation, SaveProductUnitConversionLinkMutationVariables } from "../../generated/generated-types";

@Injectable({
    providedIn: 'root'
})
export class ProductUnitConversionLinkService extends BaseListService<ProductUnitConversionLink> {

    constructor(private dataService: DataService,
        private baseDataService: BaseDataService,
        private systemService: SystemService) {
        super();

    }
    //#region implementation
    getItems(searchInput?: ProductUnitConversionLinkSearchInput) {

        let fragment = GET_PRODUCT_UNIT_CONVERSION_LINKS;

        return this.baseDataService.query<GetProductUnitConversionLinksQuery, GetProductUnitConversionLinksQueryVariables>(
            fragment, {
            input: searchInput as any
        });

    }

    getItem(id: string) {

        return this.baseDataService.query<GetProductUnitConversionLinkQuery, GetProductUnitConversionLinkQueryVariables>(
            GET_PRODUCT_UNIT_CONVERSION_LINK, {
            id: id
        });
    }

    async getItemData(id: string): Promise<ProductUnitConversionLink> {
        let result = await lastValueFrom(this.getItem(id).single$);
        return result.getProductUnitConversionLink as ProductUnitConversionLink;
    }

    getItemStream(id: string) {
        return this.getItem(id).mapStream(x => x.getProductUnitConversionLink);
    }

    async saveItem(productUnitConversionLink: ProductUnitConversionLink | ProductUnitConversionLinkInput): Promise<ProductUnitConversionLink> {

        let validated = await this.systemService.validateObject<ProductUnitConversionLinkInput>(productUnitConversionLink, "ProductUnitConversionLinkInput");

        let saved = await lastValueFrom(this.baseDataService.mutate<SaveProductUnitConversionLinkMutation, SaveProductUnitConversionLinkMutationVariables>(
            SAVE_PRODUCT_UNIT_CONVERSION_LINK, {
            input: validated
        }
        ));

        return saved.saveProductUnitConversionLink as ProductUnitConversionLink;
    }

    async deleteItem(id: string): Promise<DeletionResponse> {

        let res = await lastValueFrom(this.baseDataService.mutate<DeleteProductUnitConversionLinkMutation, DeleteProductUnitConversionLinkMutationVariables>(
            DELETE_PRODUCT_UNIT_CONVERSION_LINK, {
            id: id
        }));
        return res.deleteProductUnitConversionLink;
    }
    //#endregion

}

